import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../../../toastmsg";
import { db } from "../../../../firebase";
import { slugify } from "../../../../utils/slug";
import {
  collection,
  addDoc,
  updateDoc,
  doc,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import UniForm from "../../../../Components/Form/UniForm"; // ✅ use new UniForm

export default function AddUniversity() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // ✅ Handle adding a new university
  const handleAddUniversity = async (formData: any) => {
    setLoading(true);

    try {
      const toArray = (val: any) =>
        Array.isArray(val) ? val : val ? [val] : [];

      const newUniversity = {
        universityName: formData.universityName || "-",
        slug: slugify(formData.universityName || ""),
        intro: formData.intro || "-",
        keyInfo: toArray(formData.keyInfo),
        rankings: toArray(formData.rankings),
        campus: toArray(formData.campus),
        country: formData.country || "-",
        degreeIntake: toArray(formData.degreeIntake),
        diplomaIntake: toArray(formData.diplomaIntake),
        foundationIntake: toArray(formData.foundationIntake),
        masterIntake: toArray(formData.masterIntake),
        courses: toArray(formData.courses),
        strengthsHighlights: toArray(formData.strengthsHighlights),
      };

      // ✅ Directly add new document (no soft-delete check)
      const docRef = await addDoc(collection(db, "university-listing"), {
        ...newUniversity,
      });

      // ✅ Add the document ID field
      await updateDoc(doc(db, "university-listing", docRef.id), {
        ID: docRef.id,
      });

      navigate("/university-listing");
      showSuccessToast("University added successfully");
    } catch (error: any) {
      console.error("Error adding university:", error);
      showErrorToast(error.message || "Failed to add university");
    } finally {
      setLoading(false);
    }
  };

  // ✅ Cancel button handler
  const handleCancel = () => {
    navigate("/university-listing");
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Add New University</h2>
      <UniForm
        onSubmit={handleAddUniversity}
        onCancel={handleCancel}
        disabled={loading}
      />
    </div>
  );
}
